export const blue = '#006DB2'

export const purple9 = '#22075e'

export const green = '#5b8c00'

export const yellowPrimary = '#fa8c16'

export const greenPrimary = '#52c41a'

export const redPrimary = '#e74c3c'

export const grayPrimary = '#65676b'

export const greenButton = '#3aaf50'

export const neutral200 = '#E3E8EF'
